import { UiActions, UiActionsTypes } from './ui.actions';
import { UiState } from './ui.model';

export const inRoomUiFeatureKey = 'inroom-ui';

const initialstate: UiState = {
  isTerminalOpen: false,
};

export function uiReducer(state: UiState = initialstate, action: UiActions): UiState {
  switch (action.type) {
    case UiActionsTypes.TOGGLE_TERMINAL: {
      return {
        ...state,
        isTerminalOpen: action.payload.isOpen,
      };
    }

    default:
      return state;
  }
}
